"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScope = exports.isUngated = exports.getPickerComponent = exports.getNamespace = void 0;

var _hsSettings = require("../constants/hsSettings");

var DEFAULT_NAMESPACE = 'hubspot';

var getNamespace = function getNamespace(editor) {
  if (editor.settings[_hsSettings.HS_PLUGINS] && editor.settings[_hsSettings.HS_PLUGINS].namespaceClass) {
    return editor.settings[_hsSettings.HS_PLUGINS].namespaceClass;
  }

  return DEFAULT_NAMESPACE;
};

exports.getNamespace = getNamespace;

var getPickerComponent = function getPickerComponent(editor, pickerComponent) {
  if (editor.settings[_hsSettings.HS_PLUGINS] && editor.settings[_hsSettings.HS_PLUGINS].pickerComponents) {
    return editor.settings[_hsSettings.HS_PLUGINS].pickerComponents[pickerComponent];
  }

  return null;
};

exports.getPickerComponent = getPickerComponent;

var isUngated = function isUngated(editor, gateName) {
  var gates = editor.settings.gates;
  return Array.isArray(gates) && gates.includes(gateName);
};

exports.isUngated = isUngated;

var hasScope = function hasScope(scopeName, scopes) {
  return Array.isArray(scopes) && scopes.includes(scopeName);
};

exports.hasScope = hasScope;